import type { Copyright } from 'src/types';

const date = new Date();
const year = date.getFullYear();

export const copyright: Copyright = {
  copyright: `Copyright \u00A9 1998-${year} Jobsdb`,
};
